import PropTypes from 'prop-types';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { getComparisonConfig } from '@/stores/comparisonStore';
import { exportComparisonData } from '@/api/comparisons';

const ComparisonExportButton = ({ comparisonId, name }) => {
  const handleExport = async () => {
    try {
      const config = getComparisonConfig();
      const response = await exportComparisonData(comparisonId, config);
      const filename = `${name}.xlsx`;

      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Export failed:', error);
    }
  };

  return (
    <button onClick={handleExport} className="right-5 top-5 btn btn-sm btn-secondary mr-4">
      <ArrowDownTrayIcon className="w-5 h-5" />
      Export Data
    </button>
  );
};

ComparisonExportButton.propTypes = {
  comparisonId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  name: PropTypes.string.isRequired,
};

export default ComparisonExportButton;
